export default {
	hero: require("../assets/icons/hero.svg?inline"),
	upload: require("../assets/icons/upload.svg?inline"),
	chevron: require("../assets/icons/chevron.svg?inline"),
	frame: require("../assets/icons/frame.svg?inline"),
	tooltip: require("../assets/icons/tooltip.svg?inline"),
	facebook: require("../assets/icons/facebook.svg?inline"),
	twitter: require("../assets/icons/twitter.svg?inline"),
	email: require("../assets/icons/email.svg?inline"),

	devices: {
		desktop: require("../assets/icons/devices/desktop.svg?inline"),
		laptop: require("../assets/icons/devices/laptop.svg?inline"),
		monitor: require("../assets/icons/devices/monitor.svg?inline"),
		phone: require("../assets/icons/devices/phone.svg?inline"),
		tablet: require("../assets/icons/devices/tablet.svg?inline")
	}
};
